import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking/unknown, false = logged out
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith("/admin")) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get("/auth/me");
        if (!cancelled) setUser(r.data);
      } catch {
        try {
          const r = await api.post("/auth/refresh");
          localStorage.setItem("rb_token", r.data.access_token);
          const me = await api.get("/auth/me");
          if (!cancelled) setUser(me.data);
        } catch {
          if (!cancelled) setUser(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [location.pathname]);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("rb_token", r.data.access_token);
    setUser(r.data);
    return r.data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("rb_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
